module.exports = __webpack_public_path__ + "img/online.77cd713f.svg";